module.exports = __webpack_public_path__ + "img/forum1.e319421f.jpg";